import styled from "styled-components";

const ImageContainer = styled.div`
`;
export default ImageContainer;